import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './View.scss'
import { Fade } from '../../components/Transitions'
const View = ({ children, noPadding }) => (
	<div styleName={noPadding ? 'view-no-padding' : 'view'}>
		<Fade>{children}</Fade>
	</div>
)

View.propTypes = {
	children: React.PropTypes.node
}

export default CSSModules(View, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/View.js